var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"flex":"1","margin-left":"24px"}},[_c('a-result',{attrs:{"status":"404","title":"404","sub-title":"Sorry, the page you visited does not exist."},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"}},[_vm._v(" Back Home ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }